import { reportsChartsMenuData } from './reports-menu.data';
import { ReportsMenus } from './models/reports-menu.model';
import { ObjectNames } from './../shared/constants';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {
    private subject = new Subject<any>();
    private accountChannelList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private leadChannelList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private opportunityChannelList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private territoryChannelList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    private warehouseLocationList: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(private http: HttpClient) { }

    sendData<T>(message: T) {
        this.subject.next(message);
    }

    clearData() {
        this.subject.next(null);
    }

    getData<T>(): Observable<T> {
        return this.subject.asObservable();
    }

    clearAllData(){
        this.accountChannelList.next([]);
        this.leadChannelList.next([]);
        this.opportunityChannelList.next([]);
        this.territoryChannelList.next([]);
        this.warehouseLocationList.next([]);
    }

    async getAccountChannelList() {
        const accountChList = this.accountChannelList?.getValue();

        if (accountChList?.length > 0) {
            return accountChList;
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/Channel/SelectList/Module/2`)
                .toPromise()
                .then(channels => {
                    const accountChannel = channels;
                    accountChannel?.map(channel => {
                        if (!channel.name.toLowerCase().includes("account"))
                            channel.name = `Account ${channel.name}`;

                        if (!channel.name.toLowerCase().includes("channel"))
                            channel.name = `${channel.name} Channel`;
                    });
                    this.accountChannelList.next(accountChannel);
                });

            return this.accountChannelList.getValue();
        }
    }

    async getLeadChannelList() {
        const leadChList = this.leadChannelList?.getValue();

        if (leadChList?.length > 0) {
            return leadChList;
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/Channel/SelectList/Module/1`)
                .toPromise()
                .then(channels => {
                    const leadChannel = channels;

                    leadChannel?.map(channel => {
                        if (!channel.name.toLowerCase().includes("lead"))
                            channel.name = `Lead ${channel.name}`;

                        if (!channel.name.toLowerCase().includes("channel"))
                            channel.name = `${channel.name} Channel`;
                    });

                    this.leadChannelList.next(leadChannel);
                });

            return this.leadChannelList.getValue();
        }
    }

    async getOpportunityChannelList() {
        const opportunityChList = this.opportunityChannelList?.getValue();

        if (opportunityChList?.length > 0) {
            return opportunityChList;
        } else {
            await this.http.get<any>(`${environment.configUrlV2}/Channel/SelectAllowedList/Module/3`)
                .toPromise()
                .then(channels => {
                    const opportunityChannel = channels ? channels : [];
                    opportunityChannel.map(channel => {
                        if (!channel.name.toLowerCase().includes("opportunity"))
                            channel.name = `Opportunity ${channel.name}`;

                        if (!channel.name.toLowerCase().includes("channel"))
                            channel.name = `${channel.name} Channel`;
                    });
                    this.opportunityChannelList.next(opportunityChannel);
                });

            return this.opportunityChannelList.getValue();
        }
    }

    async getAllWarehouse() {
        let whLoations = this.warehouseLocationList?.getValue();
        if (!(whLoations?.length > 0)) {

            await this.http.get<any>(`${environment.inventoryURl}WareHouse/WarehouseWithName`)
                .toPromise()
                .then(wHouse => {
                    this.warehouseLocationList.next(wHouse);
                });
            whLoations = this.warehouseLocationList.getValue();
        }
        return whLoations;
    }

    generateReportsChanrtsMenus() {
        const reportsMenusFlat: ReportsMenus[] = reportsChartsMenuData();
        const chartsMenus = reportsMenusFlat.filter(menu => menu?.haveCharts);
        return chartsMenus;
    }
}
